import { useEffect, useState } from 'react';
import { generateTableData } from '../Util';

const TableNumData = ({ data = [] }) => {  // Ensure `data` has a default value (empty array)

    const tableData = generateTableData();

    const processedTableData = tableData.map((row) =>
        row.map((cell) => {
            // Ensure `data` is an array before calling .filter()
            const betAmount = Array.isArray(data)
                ? data
                    .filter((item) => item?.betNo?.padStart(2, '0') === cell.padStart(2, '0')) // Safe access with `?`
                    .reduce((acc, item) => acc + (Number(item?.Amount) || 0), 0) // Safe access with `?`
                : 0;

            return { cell, betAmount };
        })
    );

    return (
        <div className="card shadow mb-4">
            {/* Number Table */}
            <div className="table-responsive mt-4">
                <table className="table table-bordered">
                    <tbody>
                        {processedTableData.map((row, rowIndex) => (
                            <tr key={rowIndex}

                            >
                                {row.map(({ cell, betAmount }, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        style={{
                                            padding: "10px",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                        className={(rowIndex + cellIndex) % 2 === 0 ? "back" : "lay"}
                                    >
                                        <div style={{ display: "block" }}>
                                            <span>{cell}</span> <br />
                                            <bold className={betAmount < 0 ? 'red-text' : 'green-text'}>{Math.abs(betAmount)}</bold>
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableNumData;
